export default __webpack_public_path__ + "img/mostly-cloudy-rain.1a9e8c3.svg";